import { lazy } from 'react';

const NonTradeCollection = lazy(() => import('../pages/NonTradeCollection'));

const nonTradeCollectionScreenRoute = {
  public: [],
  auth: [
    {
      name: 'non_trade_collection',
      path: '/finance-and-accounting/non-trade-collection/:tab?',
      component: NonTradeCollection,
    },
  ],
};

export default nonTradeCollectionScreenRoute;
